import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogDescription,
  DialogHeader,
  DialogContent,
  DialogTrigger,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { FileUploader } from '@/components/ui/file-uploader';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { useUploadStore } from '@/store/uploadStore';

type DialogUploadFileProps = {
  children: React.ReactNode;
  currentPath: string[];
  handleUploadFile: (params: {
    files: File[];
    uploadPath: string;
  }) => Promise<void>;
};

const DialogUploadFile = ({
  children,
  currentPath,
  handleUploadFile,
}: DialogUploadFileProps) => {
  const [files, setFiles] = useState<File[]>([]);
  const [open, setOpen] = useState(false);
  const [uploadPath, setUploadPath] = useState(currentPath.join('/'));
  const [isUploading, setIsUploading] = useState(false);
  
  const { files: uploadingFiles } = useUploadStore();

  useEffect(() => {
    if (!open) {
      setFiles([]);
      setUploadPath(currentPath.join('/'));
    }
  }, [open, currentPath]);

  const handleUpload = async () => {
    setIsUploading(true);
    setOpen(false);
    await handleUploadFile({ files, uploadPath })
    setIsUploading(false);
    // toast.promise(handleUploadFile({ files, uploadPath }), {
    //   loading: `Starting upload of ${files.length} file(s)...`,
    //   success: `Started uploading ${files.length} file(s)`,
    //   error: 'Failed to start upload',
    //   finally: () => {
    //     setIsUploading(false);
    //     setOpen(false);
    //   },
    // });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>

      <DialogContent className="sm:max-w-xl">
        <DialogHeader>
          <DialogTitle>Upload Files</DialogTitle>
          <DialogDescription className="space-y-2">
            <p>Drag and drop your files here or click to browse.</p>
            <div className="flex flex-col gap-2">
              <Label>Path to upload</Label>
              <Input
                type="text"
                value={uploadPath}
                onChange={(e) => setUploadPath(e.target.value)}
                className="flex-1 rounded border px-2 py-1 text-sm"
              />
            </div>
          </DialogDescription>
        </DialogHeader>
        <FileUploader
          onValueChange={setFiles}
          multiple={true}
        />
        {files.length > 0 && (
          <DialogFooter>
            <Button onClick={handleUpload} disabled={isUploading}>
              {isUploading ? 'Uploading...' : 'Upload'}
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DialogUploadFile;
